<!-- /src/components/common/PostInteractions.vue -->
<template>
  <div class="button__group post-interactions__action-bar">
      <button
        v-if="useoptionalbutton"
        class="button button--sm button--shadow"
        @click="optionalButtonClicked"
      >
        {{ useoptionalbutton }}
      </button>
      <button
        class="button button--sm button--shadow button--withIcon button--withIcon--only"
        :class="bookmarkClasses"
        @click.stop.prevent="addBookmark"
        v-if="!remove.bookmark"
      >
        <span class="button__icon">
          <i v-if="bookmarkLoading" class="icon fas fa-spinner fa-pulse"></i>
          <i v-else-if="bookmarked" class="icon fas fa-bookmark"></i>
          <i v-else class="icon far fa-bookmark"></i>
        </span>
        <!-- <span class="button__text">{{ bookmarkText }}</span> -->
      </button>
      <button
        class="button button--sm button--shadow button--withIcon button--withIcon--only"
        :class="progressClasses"
        @click="markComplete"
        v-if="!remove.progress"
      >
        <span class="button__icon">
          <i v-if="completeLoading" class="icon fas fa-spinner fa-pulse"></i>
          <i
            v-else
            class="icon fa"
            :class="[isComplete ? 'fa-check-circle' : 'fa-minus-circle']"
          ></i>
        </span>
        <!-- <span v-if="isComplete == false" class="button__text">
          Mark Complete
        </span>
        <span v-else class="button__text">
          Complete
        </span> -->
      </button>
  </div>
</template>

<script>
import postMixin from '@/mixins/postMixin'
import _isUndefined from 'lodash/isUndefined'

export default {
  props: {
    post: {
      type: Object,
      required: true,
    },
    useoptionalbutton: {
      type: [String, Boolean],
      required: false,
    },
    removeButtons: {
      type: Array,
      required: false,
    },
  },

  data() {
    return {
      remove: {
        progress: false,
        bookmark: false,
      }
    }
  },

  mixins: [postMixin],

  methods: {
    optionalButtonClicked() {
      this.$emit('optionalButtonClicked')
    },

    processRemovalButtons() {
      const { removeButtons } = this
      if (!_isUndefined(removeButtons)) {
        removeButtons.forEach(btn => {
          this.remove[btn] = true
        })
      }
    }
  },

  mounted() {
    this.processRemovalButtons()
  },
}
</script>

<style scoped>
.post-interactions {

  &__action-bar {
    display: flex;
  }

}
</style>
